// Module
var code = "<div layout=\"column\" flex> <abx-dashboard abx-buildings=\"vm.buildings\"> </abx-dashboard> </div> ";
// Exports
module.exports = code;